import { cn } from "@telesoft/lib/web/cn"
import * as React from 'react'

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'min-h-[80px] flex py-2 pl-0 pr-4 md:pr-5 w-full appearance-none relative text-sm lg:text-base duration-150 ease-in-out border-b placeholder-body min-h-12 file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50',
          'bg-transparent border-heading focus:outline-none focus:border-telesoft text-input',
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  },
)
Textarea.displayName = 'Textarea'

export { Textarea }
